import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LoaderCon from "../../Common/loader/containers/loader_cont";
import Snackbar1 from "../../Common/snackbar/components/snackbar";
import {
  Info,
  Layout,
  Settings,
  Zap,
  ChevronLeft,
  Save,
  Upload,
  Shield,
  Wind,
  Music,
  CheckSquare,
  Edit3
} from "lucide-react";
import "./AddOldCarFlow.css";

export default function Edit(props) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState('basic');

  // --- State Variables ---
  const [oldImages, setOldImages] = useState([]);
  const [newImages, setNewImages] = useState([]);

  // Basic Info States
  const [brand, setBrand] = useState("");
  const [carName, setCarName] = useState("");
  const [fuelType, setFuelType] = useState("");
  const [carType, setCarType] = useState("");
  const [price, setPrice] = useState("");
  const [discountedPrice, setDiscountedPrice] = useState("");
  const [kilometer, setKilometer] = useState("");

  // Overview States
  const [registerationYear, setRegisterationYear] = useState("");
  const [manufacturingYear, setManufacturingYear] = useState("");
  const [owners, setOwners] = useState("");
  const [transmission, setTransmission] = useState("");
  const [color, setColor] = useState("");
  const [insurance, setInsurance] = useState("");
  const [registerationType, setregisterationType] = useState("");
  const [description, setDescription] = useState("");

  // Specification States
  const [engine, setEngine] = useState("");
  const [maxPower, setMaxPower] = useState("");
  const [maxTorque, setMaxTorque] = useState("");
  const [mileage, setMileage] = useState("");
  const [driveTrain, setDriveTrain] = useState("");
  const [length, setLength] = useState("");
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [wheelbase, setWheelbase] = useState("");
  const [groundClearance, setGroundClearance] = useState("");
  const [kerbWeight, setKerbWeight] = useState("");
  const [doors, setDoors] = useState("");
  const [seatingCapacity, setSeatingCapacity] = useState("");
  const [rows, setRows] = useState("");
  const [bootspace, setBootspace] = useState("");
  const [fuelTankCapacity, setFuelTankCapacity] = useState("");
  const [frontSuspension, setFrontSuspension] = useState("");
  const [rearSuspension, setRearSuspension] = useState("");
  const [frontbrakeType, setFrontBrakeType] = useState("");
  const [rearBrakeType, setRearBrakeType] = useState("");
  const [minTurningRadius, setMinTurningRadius] = useState("");
  const [steeringType, setSteeringType] = useState("");
  const [wheels, setWheels] = useState("");
  const [spareWheel, setSpareWheel] = useState("");
  const [frontTyres, setFrontTyres] = useState("");
  const [rearTyres, setRearTyres] = useState("");

  // Feature States (Matching Feature.js)
  const [formFeatures, setFormFeatures] = useState({
    airbag: "",
    tyrePresssure: false,
    childSeatAnchorPoints: false,
    seatBeltWarning: false,
    abs: false,
    ebd: false,
    ba: false,
    esp: false,
    fourWheel: false,
    hillHoldControl: false,
    tcs: false,
    hillDescentControl: false,
    engineImmobiliser: false,
    centeralLocking: false,
    speedSensingDoorLock: false,
    childSafetyLock: false,
    ac: false,
    frontac: false,
    rearac: false,
    heater: false,
    vanityMirror: false,
    antiglareMirror: false,
    parkingAssist: false,
    parkingSensor: false,
    cruisecontrol: false,
    headlightIgnition: false,
    keylessstart: false,
    steeringAdjustment: false,
    power: false,
    applecarplay: false,
    androidauto: false,
    seatUpholestry: false,
    drivesideAdjust: false,
    leatherWrapped: false,
    driverArmrest: false,
    foldingRearSeat: false,
    splitRearSeat: false,
    splitThirdRowSeat: false,
    frontSeatbackPockets: false,
    headrests: false,
    cupholders: false,
    driverArmrestStorage: false,
    cooledGloveBox: false,
    sunGlassHolder: false,
    thirdRowCupHolder: false,
    orvm: false,
    powerWindow: false,
    oneTouchDown: false,
    oneTouchUp: false,
    adjustableOrvm: false,
    exteriorDoorHandle: false,
    chromeexteriorDoorHandle: false,
    doorPockets: false,
    bootlidOpener: false,
    sunroof: false,
    roofMountedAntenna: false,
    bodyColouredBumpers: false,
    chromeFinish: false,
    projectorheadlight: false,
    autoheadlamps: false,
    homeheadlamps: false,
    drl: false,
    tailights: false,
    cabinLamps: false,
    lightonVanityMirror: false,
    rearreadinglamp: false,
    gloveBoxlamp: false,
    headlightHeightAdjuster: false,
    tripMeter: false,
    averageFuelConsumption: false,
    distancetoEmpty: false,
    clock: false,
    lowFuelWarning: false,
    doorAjarWarning: false,
    adjustableCluster: false,
    gearIndicator: false,
    shiftIndicator: false,
    tachometer: false,
    musicSystem: false,
    speaker: false,
    steeringmountedctrls: false,
    voiceCommand: false,
    gps: false,
    bluetooth: false,
    aux: false,
    radio: false,
    usb: false,
    headUnitSize: false,
    des12: "",
  });

  // --- Feature Categorization (Parity with Feature.js) ---
  const featureSections = [
    {
      title: "Safety",
      icon: <Shield size={20} />,
      items: [
        ["tyrePresssure", "TPMS"],
        ["childSeatAnchorPoints", "Child Seat Anchors"],
        ["seatBeltWarning", "Seat Belt Warning"],
        ["abs", "ABS"],
        ["ebd", "EBD"],
        ["ba", "Brake Assist"],
        ["esp", "ESP"],
      ]
    },
    {
      title: "Locks & Security",
      icon: <Zap size={20} />,
      items: [
        ["engineImmobiliser", "Engine Immobiliser"],
        ["centeralLocking", "Central Locking"],
        ["speedSensingDoorLock", "Speed Sensing Door Lock"],
        ["childSafetyLock", "Child Safety Lock"],
        ["keylessstart", "Keyless / Button Start"],
      ]
    },
    {
      title: "Comfort & Convenience",
      icon: <Wind size={20} />,
      items: [
        ["ac", "Air Conditioner"],
        ["frontac", "Front AC"],
        ["rearac", "Rear AC"],
        ["heater", "Heater"],
        ["cruisecontrol", "Cruise Control"],
        ["parkingSensor", "Parking Sensors"],
        ["parkingAssist", "Parking Assist"],
        ["power", "12V Power Outlets"],
      ]
    },
    {
      title: "Entertainment & Connectivity",
      icon: <Music size={20} />,
      items: [
        ["musicSystem", "Integrated Music System"],
        ["speaker", "Speakers"],
        ["steeringmountedctrls", "Steering Controls"],
        ["applecarplay", "Apple CarPlay"],
        ["androidauto", "Android Auto"],
        ["bluetooth", "Bluetooth"],
        ["gps", "GPS Navigation"],
      ]
    },
    {
      title: "Exterior & Lighting",
      icon: <Settings size={20} />,
      items: [
        ["sunroof", "Sunroof"],
        ["projectorheadlight", "Projector Headlamps"],
        ["drl", "DRL"],
        ["tailights", "LED Taillights"],
        ["autoheadlamps", "Auto Headlamps"],
        ["orvm", "Body Color ORVM"],
      ]
    }
  ];

  // --- Effects ---
  useEffect(() => {
    if (id) {
      props.viewOldCarById(props.login.token, props.login.user_id, id);
      props.viewOverviewById(props.login.token, props.login.user_id, id);
      props.viewSpecificationById(props.login.token, props.login.user_id, id);
      props.viewFeturesById(props.login.token, props.login.user_id, id);
    }
  }, [id, props.login.token, props.login.user_id]);

  useEffect(() => {
    const car = props.client.viewoldCarById;
    if (car && Object.keys(car).length > 0) {
      setBrand(car.brand || "");
      setCarName(car.carName || "");
      setFuelType(car.fuelType || "");
      setCarType(car.carType || "");
      setPrice(car.price || "");
      setDiscountedPrice(car.discountedPrice || "");
      setKilometer(car.kilometer || "");
      setOldImages(car.image || []);
    }
  }, [props.client.viewoldCarById]);

  useEffect(() => {
    const ov = props.client.viewOverviewById;
    if (ov && Object.keys(ov).length > 0) {
      setRegisterationYear(ov.registerationYear || "");
      setManufacturingYear(ov.manufacturingYear || "");
      setOwners(ov.owners || "");
      setTransmission(ov.transmission || "");
      setColor(ov.color || "");
      setInsurance(ov.insurance || "");
      setregisterationType(ov.registerationType || "");
      setDescription(ov.description || "");
    }
  }, [props.client.viewOverviewById]);

  useEffect(() => {
    const s = props.client.viewSpecificationById;
    if (s && Object.keys(s).length > 0) {
      setEngine(s.engine || "");
      setMaxPower(s.maxPower || "");
      setMaxTorque(s.maxTorque || "");
      setMileage(s.mileage || "");
      setDriveTrain(s.driveTrain || "");
      setLength(s.length || "");
      setWidth(s.width || "");
      setHeight(s.height || "");
      setWheelbase(s.wheelbase || "");
      setGroundClearance(s.groundClearance || "");
      setKerbWeight(s.kerbWeight || "");
      setDoors(s.doors || "");
      setSeatingCapacity(s.seatingCapacity || "");
      setRows(s.rows || "");
      setBootspace(s.bootspace || "");
      setFuelTankCapacity(s.fuelTankCapacity || "");
      setFrontSuspension(s.frontSuspension || "");
      setRearSuspension(s.rearSuspension || "");
      setFrontBrakeType(s.frontbrakeType || "");
      setRearBrakeType(s.rearBrakeType || "");
      setMinTurningRadius(s.minTurningRadius || "");
      setSteeringType(s.steeringType || "");
      setWheels(s.wheels || "");
      setSpareWheel(s.spareWheel || "");
      setFrontTyres(s.frontTyres || "");
      setRearTyres(s.rearTyres || "");
    }
  }, [props.client.viewSpecificationById]);

  useEffect(() => {
    const f = props.client.viewFetureById;
    if (f && Object.keys(f).length > 0) {
      setFormFeatures(prev => ({
        ...prev,
        ...f
      }));
    }
  }, [props.client.viewFetureById]);

  // --- Handlers ---
  const handleFeatureChange = (key, value) => {
    setFormFeatures(prev => ({ ...prev, [key]: value }));
  };

  const handleUpdate = (type) => {
    const { token, user_id } = props.login;
    if (type === 'basic') {
      const imagesData = newImages.map((img, index) => ({ [`image${index + 1}`]: img }));
      props.editCarinfo(token, user_id, id, brand, carName, fuelType, carType, price, discountedPrice, kilometer, imagesData, oldImages);
    } else if (type === 'overview') {
      if (props.client.viewOverviewById?._id) {
        props.editCarOverview(token, user_id, props.client.viewOverviewById._id, registerationYear, manufacturingYear, owners, transmission, color, insurance, registerationType, description);
      } else {
        props.addOverview(token, user_id, id, registerationYear, manufacturingYear, owners, transmission, color, insurance, registerationType, description);
      }
    } else if (type === 'specs') {
      if (props.client.viewSpecificationById?._id) {
        props.editCarSpecification(token, user_id, props.client.viewSpecificationById._id, engine, maxPower, maxTorque, mileage, driveTrain, length, width, height, wheelbase, groundClearance, kerbWeight, doors, seatingCapacity, rows, bootspace, fuelTankCapacity, frontSuspension, rearSuspension, frontbrakeType, rearBrakeType, minTurningRadius, steeringType, wheels, spareWheel, frontTyres, rearTyres);
      } else {
        props.addSpecification(token, user_id, id, engine, maxPower, maxTorque, mileage, driveTrain, length, width, height, wheelbase, groundClearance, kerbWeight, doors, seatingCapacity, rows, bootspace, fuelTankCapacity, frontSuspension, rearSuspension, frontbrakeType, rearBrakeType, minTurningRadius, steeringType, wheels, spareWheel, frontTyres, rearTyres);
      }
    } else if (type === 'features') {
      if (props.client.viewFetureById?._id) {
        props.editCarFeature(token, user_id, props.client.viewFetureById._id, ...Object.values(formFeatures));
      } else {
        props.addFeature(token, user_id, id, ...Object.values(formFeatures));
      }
    }
  };

  const tabs = [
    { id: 'basic', label: 'Basic Info', icon: Info },
    { id: 'overview', label: 'Overview', icon: Layout },
    { id: 'specs', label: 'Specifications', icon: Settings },
    { id: 'features', label: 'Features', icon: Zap }
  ];

  const renderBasicInfo = () => (
    <div className="flow-form">
      <div className="edit-section-title"><Edit3 size={20} color="#cf2230" /> Core Details & Media</div>

      <div className="flow-group full-width">
        <label className="flow-label">Vehicle Images (New uploads overwrite gallery)</label>
        <div className="image-preview-grid">
          {newImages.length > 0 ? newImages.map((img, i) => (
            <div key={i} className="preview-img-container"><img src={URL.createObjectURL(img)} alt="" /></div>
          )) : oldImages.map((img, i) => (
            <div key={i} className="preview-img-container"><img src={img} alt="" /></div>
          ))}
        </div>
        <label className="image-upload-wrapper" style={{ marginTop: '16px' }}>
          <Upload className="upload-icon" />
          <p>Click to replace photos</p>
          <input type="file" hidden multiple onChange={(e) => setNewImages(Array.from(e.target.files))} />
        </label>
      </div>

      <div className="flow-grid">
        <div className="flow-group">
          <label className="flow-label">Brand</label>
          <select className="flow-select" value={brand} onChange={(e) => setBrand(e.target.value)}>
            <option value="">Select Brand</option>
            {["MG Motor", "Audi", "BMW", "Mercedes-Benz", "Tata", "Hyundai", "Maruti Suzuki", "Toyota", "Kia"].map(b => (
              <option key={b} value={b}>{b}</option>
            ))}
          </select>
        </div>
        <div className="flow-group">
          <label className="flow-label">Car Name</label>
          <input className="flow-input" value={carName} onChange={(e) => setCarName(e.target.value)} />
        </div>
        <div className="flow-group">
          <label className="flow-label">Fuel Type</label>
          <select className="flow-select" value={fuelType} onChange={(e) => setFuelType(e.target.value)}>
            {["Petrol", "Diesel", "Electric", "Hybrid", "CNG"].map(f => (
              <option key={f} value={f}>{f}</option>
            ))}
          </select>
        </div>
        <div className="flow-group">
          <label className="flow-label">Car Type</label>
          <select className="flow-select" value={carType} onChange={(e) => setCarType(e.target.value)}>
            {["SUV", "Sedan", "Hatchback", "Luxury", "MUV"].map(t => (
              <option key={t} value={t}>{t}</option>
            ))}
          </select>
        </div>
        <div className="flow-group">
          <label className="flow-label">Market Price (₹)</label>
          <input className="flow-input" type="number" value={price} onChange={(e) => setPrice(e.target.value)} />
        </div>
        <div className="flow-group">
          <label className="flow-label">Discounted Price (₹)</label>
          <input className="flow-input" type="number" value={discountedPrice} onChange={(e) => setDiscountedPrice(e.target.value)} />
        </div>
        <div className="flow-group">
          <label className="flow-label">Kilometers</label>
          <input className="flow-input" type="number" value={kilometer} onChange={(e) => setKilometer(e.target.value)} />
        </div>
      </div>
      <div className="flow-actions">
        <button className="flow-btn-primary" onClick={() => handleUpdate('basic')}><Save size={18} /> Update Core Info</button>
      </div>
    </div>
  );

  const renderOverview = () => (
    <div className="flow-form">
      <div className="edit-section-title"><Layout size={20} color="#cf2230" /> Market History</div>
      <div className="flow-grid">
        <div className="flow-group">
          <label className="flow-label">Reg. Year</label>
          <input className="flow-input" value={registerationYear} onChange={(e) => setRegisterationYear(e.target.value)} />
        </div>
        <div className="flow-group">
          <label className="flow-label">Owners</label>
          <select className="flow-select" value={owners} onChange={(e) => setOwners(e.target.value)}>
            <option value="First Owner">First Owner</option>
            <option value="Second Owner">Second Owner</option>
            <option value="Third or More">Third or More</option>
          </select>
        </div>
        <div className="flow-group">
          <label className="flow-label">Transmission</label>
          <select className="flow-select" value={transmission} onChange={(e) => setTransmission(e.target.value)}>
            <option value="Manual">Manual</option>
            <option value="Automatic">Automatic</option>
          </select>
        </div>
        <div className="flow-group">
          <label className="flow-label">Insurance</label>
          <input className="flow-input" value={insurance} onChange={(e) => setInsurance(e.target.value)} />
        </div>
      </div>
      <div className="flow-group full-width">
        <label className="flow-label">Seller's Description</label>
        <textarea className="flow-textarea" value={description} onChange={(e) => setDescription(e.target.value)} />
      </div>
      <div className="flow-actions">
        <button className="flow-btn-primary" onClick={() => handleUpdate('overview')}><Save size={18} /> Update History</button>
      </div>
    </div>
  );

  const renderSpecs = () => (
    <div className="flow-form">
      <div className="edit-section-title"><Settings size={20} color="#cf2230" /> Technical Data</div>
      <div className="flow-grid">
        <div className="flow-group">
          <label className="flow-label">Engine (cc)</label>
          <input className="flow-input" value={engine} onChange={(e) => setEngine(e.target.value)} />
        </div>
        <div className="flow-group">
          <label className="flow-label">Drivetrain</label>
          <input className="flow-input" value={driveTrain} onChange={(e) => setDriveTrain(e.target.value)} />
        </div>
        <div className="flow-group">
          <label className="flow-label">Mileage (kmpl)</label>
          <input className="flow-input" value={mileage} onChange={(e) => setMileage(e.target.value)} />
        </div>
        <div className="flow-group">
          <label className="flow-label">Doors</label>
          <input className="flow-input" value={doors} onChange={(e) => setDoors(e.target.value)} />
        </div>
        <div className="flow-group">
          <label className="flow-label">Seating</label>
          <input className="flow-input" value={seatingCapacity} onChange={(e) => setSeatingCapacity(e.target.value)} />
        </div>
      </div>
      <div className="flow-actions">
        <button className="flow-btn-primary" onClick={() => handleUpdate('specs')}><Save size={18} /> Update Specs</button>
      </div>
    </div>
  );

  const renderFeatures = () => (
    <div className="flow-form">
      <div className="edit-section-title"><Zap size={20} color="#cf2230" /> Features & Equipment</div>

      <div className="flow-group">
        <label className="flow-label">Airbags</label>
        <select className="flow-select" value={formFeatures.airbag} onChange={(e) => handleFeatureChange("airbag", e.target.value)}>
          <option value="">Select Airbags</option>
          {["No Airbag", "2 Airbags", "4 Airbags", "6 Airbags"].map(a => (
            <option key={a} value={a}>{a}</option>
          ))}
        </select>
      </div>

      {featureSections.map((section, idx) => (
        <div key={idx} className="feature-category">
          <h3 className="category-title">{section.icon} {section.title}</h3>
          <div className="feature-grid">
            {section.items.map(([key, label]) => (
              <div
                key={key}
                className={`feature-checkbox-card ${formFeatures[key] ? 'active' : ''}`}
                onClick={() => handleFeatureChange(key, !formFeatures[key])}
              >
                <div style={{
                  width: '20px', height: '20px', borderRadius: '4px', border: '2px solid',
                  borderColor: formFeatures[key] ? 'var(--accent)' : '#cbd5e1',
                  background: formFeatures[key] ? 'var(--accent)' : 'white',
                  display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                  {formFeatures[key] && <CheckSquare size={14} color="white" />}
                </div>
                <span style={{ fontSize: '14px' }}>{label}</span>
              </div>
            ))}
          </div>
        </div>
      ))}

      <div className="flow-actions">
        <button className="flow-btn-primary" onClick={() => handleUpdate('features')}><Save size={18} /> Update Features</button>
      </div>
    </div>
  );

  if (!brand && !carName && props.loader.loader) return <LoaderCon />;

  return (
    <div className="old-car-flow-container" style={{ backgroundColor: '#f8fafc' }}>
      <div style={{ maxWidth: '1000px', margin: '0 auto', width: '100%', padding: '0 20px' }}>

        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '32px' }}>
          <button onClick={() => navigate(-1)} className="flow-btn-secondary" style={{ padding: '10px', borderRadius: '50%', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <ChevronLeft size={24} />
          </button>
          <div>
            <h1 style={{ fontSize: '24px', fontWeight: '800', margin: 0 }}>Edit vehicle details</h1>
            <p style={{ color: '#64748b', margin: 0 }}>Modifying: {carName}</p>
          </div>
        </div>

        <div className="edit-tabs-container">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`edit-tab-btn ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <tab.icon size={18} />
              {tab.label}
            </button>
          ))}
        </div>

        <div className="old-car-flow-card">
          {activeTab === 'basic' && renderBasicInfo()}
          {activeTab === 'overview' && renderOverview()}
          {activeTab === 'specs' && renderSpecs()}
          {activeTab === 'features' && renderFeatures()}
        </div>
      </div>
      <LoaderCon />
      <Snackbar1 open={props.snackbar.response_received} close_snack_bar={() => props.close_snack_bar()} message={props.snackbar.message} />
    </div>
  );
}
